<template>
    <div class="pagination">
        <button @click="changePage(1)" :disabled="currentPage === 1">&lt;&lt;</button>
        <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1"> &lt; </button>

        <button v-for="page in pagesToShow" :key="page" @click="changePage(page)"
            :class="{ active: page === currentPage }">
            {{ page }}
        </button>

        <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">&gt;</button>
        <button @click="changePage(totalPages)" :disabled="currentPage === totalPages">&gt;&gt;</button>
    </div>
</template>

<script>
export default {
    props: {
        totalPages: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
        maxPagesToShow: {
            type: Number,
            default: 5
        }
    },
    computed: {
        pagesToShow() {
            const pages = [];
            const half = Math.floor(this.maxPagesToShow / 2);

            let start = Math.max(this.currentPage - half, 1);
            let end = Math.min(this.currentPage + half, this.totalPages);

            if (end - start < this.maxPagesToShow - 1) {
                if (start === 1) {
                    end = Math.min(this.maxPagesToShow, this.totalPages);
                } else if (end === this.totalPages) {
                    start = Math.max(this.totalPages - this.maxPagesToShow + 1, 1);
                }
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        }
    },
    methods: {
        changePage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.$emit('page-changed', page);
            }
        }
    }
};
</script>

<style scoped>
.pagination {
    display: flex;
    align-items: center;
}

.pagination button {
    margin: 0 2px;
    padding: 5px 10px;
    cursor: pointer;
}

.pagination .active {
    font-weight: bold;
    color: #69BE28
}
</style>
